/* Moved from the inline <script> in snippets/filter-icons.liquid (PageSpeed batch 6). Guarded so it runs once even if the snippet renders twice. */
(function () {
  if (window.__kgFilterIconsLoaded) return;
  window.__kgFilterIconsLoaded = true;

    document.addEventListener("DOMContentLoaded", function () {
  const duschhornBtns = document.querySelectorAll(".duschhorn-filter-btn");

  duschhornBtns.forEach(btn => {
    btn.addEventListener("click", function (event) {
      event.preventDefault();

      const tag = this.getAttribute("data-tag");
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);

      searchParams.delete("filter.p.m.custom.shower");
      searchParams.set("filter.p.m.custom.shower", tag);

      window.location.href = `${url.pathname}?${searchParams.toString()}`;
    });
  });
});

      document.addEventListener("DOMContentLoaded", function () {
        const colorSwatches = document.querySelectorAll(".color-filter-swatch");
        const sizeButtons = document.querySelectorAll(".size-filter-button");
        const filterForm = document.getElementById("facets");
        const colorContainer = document.querySelector(".color-filter-container");
        const sizeContainer = document.querySelector(".size-filter-container");
        const scrollBtn = document.querySelector(".scroll-button:not(.size-scroll-button)");
        const sizeScrollBtn = document.querySelector(".size-scroll-button");
        const colorHeading = document.getElementById("color-heading");
        const sizeHeading = document.getElementById("size-heading");
        if (sessionStorage.getItem("showSizeFilter") === "true") {
          sessionStorage.removeItem("showSizeFilter");
          if (colorContainer) {
            colorContainer.classList.add("hidden");
            colorContainer.style.display = "none";
          }
          if (scrollBtn) {
            scrollBtn.style.display = "none";
          }
          if (sizeContainer) {
            sizeContainer.style.display = "flex";
            sizeContainer.classList.remove("hidden");
          }
          if (sizeScrollBtn) {
            sizeScrollBtn.style.display = "block";
          }
          if (colorHeading) {
            colorHeading.classList.add("hidden");
            colorHeading.style.display = "none";
          }
          if (sizeHeading) {
            sizeHeading.classList.remove("hidden");
            sizeHeading.style.display = "block";
          }
        }
        if (colorContainer && scrollBtn) {
          function updateColorScrollButton() {
            const isOverflowing = colorContainer.scrollWidth > colorContainer.clientWidth;
            scrollBtn.style.display = isOverflowing ? "block" : "none";
            if (colorContainer.scrollLeft + colorContainer.clientWidth >= colorContainer.scrollWidth) {
              scrollBtn.innerHTML = "&lt;";
              scrollBtn.classList.add("left");
              scrollBtn.classList.remove("right");
            } else {
              scrollBtn.innerHTML = "&gt;";
              scrollBtn.classList.add("right");
              scrollBtn.classList.remove("left");
            }
          }
          scrollBtn.addEventListener("click", function () {
            const scrollDistance = 150;
            const scrollBack = 800;
            if (scrollBtn.classList.contains("right")) {
              colorContainer.scrollBy({ left: scrollDistance, behavior: "smooth" });
            } else {
              colorContainer.scrollBy({ left: -scrollBack, behavior: "smooth" });
            }
            setTimeout(updateColorScrollButton, 300);
          });
          colorContainer.addEventListener("scroll", updateColorScrollButton);
          updateColorScrollButton();
        }
        if (sizeContainer && sizeScrollBtn) {
          function updateSizeScrollButton() {
            const isOverflowing = sizeContainer.scrollWidth > sizeContainer.clientWidth;
            sizeScrollBtn.style.display = isOverflowing ? "block" : "none";
            if (sizeContainer.scrollLeft + sizeContainer.clientWidth >= sizeContainer.scrollWidth) {
              sizeScrollBtn.innerHTML = "&lt;";
              sizeScrollBtn.classList.add("left");
              sizeScrollBtn.classList.remove("right");
            } else {
              sizeScrollBtn.innerHTML = "&gt;";
              sizeScrollBtn.classList.add("right");
              sizeScrollBtn.classList.remove("left");
            }
          }
          sizeScrollBtn.addEventListener("click", function () {
            const scrollDistance = 150;
            const scrollBack = 800;
            if (sizeScrollBtn.classList.contains("right")) {
              sizeContainer.scrollBy({ left: scrollDistance, behavior: "smooth" });
            } else {
              sizeContainer.scrollBy({ left: -scrollBack, behavior: "smooth" });
            }
            setTimeout(updateSizeScrollButton, 300);
          });
          sizeContainer.addEventListener("scroll", updateSizeScrollButton);
          updateSizeScrollButton();
        }
        if (!filterForm) return;
        // Color swatch click
        colorSwatches.forEach((swatch) => {
          swatch.addEventListener("click", function (event) {
            event.preventDefault();
            const selectedColor = (this.getAttribute("data-value") || this.getAttribute("data-color")).trim();
            sessionStorage.setItem("showSizeFilter", "true");
            const url = new URL(window.location.href);
            const searchParams = new URLSearchParams(url.search);
            const sortBy = searchParams.get("sort_by") || "manual";
            searchParams.delete("filter.p.m.magento.farg");
            searchParams.set("filter.p.m.magento.farg", selectedColor);
            searchParams.set("sort_by", sortBy);
            window.location.href = `${url.pathname}?${searchParams.toString()}`;
          });
        });
        // Size button click
        sizeButtons.forEach((btn) => {
          btn.addEventListener("click", function (event) {
            event.preventDefault();
            const selectedSize = this.getAttribute("data-size").trim();
            const url = new URL(window.location.href);
            const searchParams = new URLSearchParams(url.search);
            const sortBy = searchParams.get("sort_by") || "manual";
            searchParams.delete("filter.p.m.magento.matt_cm");
            searchParams.set("filter.p.m.magento.matt_cm", selectedSize);
            searchParams.set("sort_by", sortBy);
            window.location.href = `${url.pathname}?${searchParams.toString()}`;
          });
        });
      });
})();
